import {
  callApi,
} from './common';
import * as apiTypes from '../../constants/Api';

/**
 * Call the API using POST.
 * @param  {Object} params  The params for the service.
 * @return void.
 */
const callDebugApiPost = (params) => {
  const url = `${apiTypes.DEBUG_ENDPOINT}`;
  return callApi('post', url, params).then(data => {
    return {
      ...data.data,
      usedParams: params,
    };
  });
};

/**
 * Dispatches the create action.
 * @param  {Object} params The params to call the service with.
 * @return void
 */
const callDebug = (params) => {
  return callDebugApiPost(params);
};

/**
 * Send Request for debug.
 * @param params
 * @return void
 */
export const requestDebug = (params) => {
  return callDebug(params);
};
